import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ApplicationStore {
  realm: string | null;
  token: string | null;
  setRealm: (realm: string) => void;
  setToken: (token: string) => void;
}

export const useApplicationStore = create<ApplicationStore>()(
  devtools(
    set => ({
      realm: null,
      token: null,
      setRealm: realm => set({ realm }),
      setToken: token => set({ token })
    }),
    { name: 'ApplicationStore' }
  )
);

export const useRealm = () => useApplicationStore(state => state.realm);
export const useToken = () => useApplicationStore(state => state.token);
